import Ajax from '../common/ajax'

export default {
  model: 'vip',
  vipList (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/vipList`, queryParam)
  },
  exportVipExcel (queryParam) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/exportVipExcel`, queryParam)
  },
  getVipDetail (applyId) {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/detail/${applyId}`)
  },
  // 申请列表
  applyVipList (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/applyVipList`, queryParam)
  },
  // 审核
  audit (queryParam) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/audit`, queryParam)
  },
  // 导出申请名单
  exportApplyVipExcel (queryParam) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/exportApplyVipExcel`, queryParam)
  },
  // 保存
  addOrUpdate (queryParam) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/addOrUpdate`, queryParam)
  },
  // 新会员直接新增
  save (queryParam) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/save`, queryParam)
  },
  // 缴费更新
  updatePayStatus (queryParam) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/updatePayStatus`, queryParam)
  },
  // 获取现属团体
  agentList () {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/agentList`)
  },
  // 校验提交申请的时候校验证件号是否重复
  isIDNoRepeat (queryParam) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/isIDNoRepeat`, queryParam)
  }
}
